module.exports = __webpack_public_path__ + "static/media/arrow-icon-back.e8e57773.svg";